import { z } from "zod";

import { ThemeDtoSchema } from "../../../schemas/organization";

export const GetThemesResponseBodySchema = z.object({
  themes: ThemeDtoSchema.array(),
});

export type GetThemesResponseBodyType = z.infer<
  typeof GetThemesResponseBodySchema
>;
